<script lang="ts">
  let { open = $bindable(false), title = "", onClose, children, footer } = $props<{
    open?: boolean;
    title?: string;
    onClose?: () => void;
    children?: any;
    footer?: any;
  }>();

  function close() {
    open = false;
    onClose?.();
  }

  function onKey(e: KeyboardEvent) {
    if (e.key === "Escape" && open) close();
  }
</script>

<svelte:window onkeydown={onKey} />

{#if open}
  <div class="modal-backdrop" role="dialog" aria-modal="true" aria-label={title}>
    <button type="button" class="absolute inset-0 w-full h-full cursor-default" aria-label="Fechar"
            onclick={close}></button>
    <div class="modal-panel">
      {#if title}
        <div class="flex items-start justify-between mb-3">
          <h2 class="text-lg font-semibold">{title}</h2>
          <button type="button" class="btn-ghost -mr-2 -mt-2" onclick={close} aria-label="Fechar">✕</button>
        </div>
      {/if}
      <div>{@render children?.()}</div>
      {#if footer}
        <div class="mt-5 flex justify-end gap-2">{@render footer?.()}</div>
      {/if}
    </div>
  </div>
{/if}
